import { iconList } from './iconList';

function scoreIcon(icon, queryTokens) {
  let score = 0;

  for (const q of queryTokens) {
    let matched = false;

    for (const token of icon.tokens) {
      if (token === q) {
        score += 10; // exact match
        matched = true;
        break;
      }

      if (token.startsWith(q)) {
        score += 6; // prefix match
        matched = true;
        break;
      }

      if (token.includes(q)) {
        score += 3; // partial match
        matched = true;
      }
    }

    if (!matched) {
      return 0; // require all query terms to match something
    }
  }

  // shorter names rank higher
  score += Math.max(0, 5 - icon.tokens.length);

  return score;
}

export const fuzzySearchIcons = (query) => {
  const queryTokens = query
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);

  if (!queryTokens.length) {
    return iconList.slice(0, 100);
  }

  return iconList
    .map(icon => ({
      icon,
      score: scoreIcon(icon, queryTokens)
    }))
    .filter(entry => entry.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 100)
    .map(entry => entry.icon);
}